import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockUnlocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.1667 1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.5 5.16667V3.83333C2.5 1.99238 3.99238 0.5 5.83333 0.5C7.20021 0.5 8.37493 1.32273 8.8893 2.5M5.83333 8.16667V9.5M3.7 12.5H7.96667C9.08677 12.5 9.64682 12.5 10.0746 12.282C10.451 12.0903 10.7569 11.7843 10.9487 11.408C11.1667 10.9802 11.1667 10.4201 11.1667 9.3V8.36667C11.1667 7.24656 11.1667 6.68651 10.9487 6.25869C10.7569 5.88236 10.451 5.5764 10.0746 5.38465C9.64682 5.16667 9.08677 5.16667 7.96667 5.16667H3.7C2.5799 5.16667 2.01984 5.16667 1.59202 5.38465C1.2157 5.5764 0.909734 5.88236 0.717987 6.25869C0.5 6.68651 0.5 7.24656 0.5 8.36667V9.3C0.5 10.4201 0.5 10.9802 0.717987 11.408C0.909734 11.7843 1.2157 12.0903 1.59202 12.282C2.01984 12.5 2.5799 12.5 3.7 12.5Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgLockUnlocked;
